import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { dict } from "../content/texts";

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => "en");
  console.log(lang)
  useEffect(() => { localStorage.setItem("lang", lang); }, [lang]);

  const value = useMemo(() => ({
    lang,
    setLang,
    toggleLang: () => setLang(l => (l === "en" ? "bg" : "en")),
    t: dict[lang] || dict.en,           // 👈 достъп до текстовете за текущия език
  }), [lang]);

  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
